import type { Product } from '@forest/native-services'
import { atom } from 'nanostores'

export const $product = atom<Product | undefined>()

export function setProduct(product: Product) {
  $product.set(product)
}

export type ChinaAndroidTrialEligibility =
  | 'pending'
  | 'available'
  | 'unavailable'

export const $chinaAndroidTrialEligibility =
  atom<ChinaAndroidTrialEligibility>('pending')
